import { WritableDraft } from '@reduxjs/toolkit';

import { PageModuleType } from '@/types/module.types';
import { Speaker } from '@/types/speakers.types';
import { ProjectState } from '../../types';
import { Session } from '@/types/session.types';

/**
 * extra-reducers helper to keep speakers in sync between speakers slice and project slice.
 *
 * When a speaker is updated, find all matching speakers in redux project sessions and update them too
 * */
const handleSpeakerMutations = (updatedSpeaker: Speaker, state: WritableDraft<ProjectState>) => {
  if (updatedSpeaker) {
    if (state?.workingProject?.sessions?.length) {
      state.workingProject.sessions = state.workingProject.sessions.map((session) => {
        return handleMutateSessionModules(updatedSpeaker, session);
      });
    }
    if (state.workingSession) {
      state.workingSession = handleMutateSessionModules(updatedSpeaker, state.workingSession);
    }
  }
};

export default handleSpeakerMutations;

const handleMutateSessionModules = (updatedSpeaker: Speaker, session: Session): Session => {
  const modules = session.modules;
  if (!modules.length) return session;
  session.modules = session.modules.map((module) => {
    if (module.type !== PageModuleType.speakers) {
      return module;
    }
    if (!module.modules?.length) {
      return module;
    }
    module.modules = module.modules.map((moduleSpeaker) => {
      if (moduleSpeaker.speaker === updatedSpeaker.speaker) {
        return updatedSpeaker;
      }
      return moduleSpeaker;
    });
    return module;
  });
  return session;
};
